import {useEffect, useState} from "react";
import {useApplicantStore} from "../stores/applicantStore";
import {ApiService} from "../api/ApiService";
import {Applicant} from "../api/types/Applicant";

export const useClientCheck = (clientId?: number): {
    client: Applicant | null,
    loading: boolean,
    refresh: (arg0: number) => void
} => {
    const applicantStore = useApplicantStore();
    const [loading, setLoading] = useState<boolean>(true);

    const refresh = (fetchApplicantId: number) => {
        setLoading(true);
        ApiService.GetApplicant(fetchApplicantId).then(a => {
            if (a.success) {
                applicantStore.setClient(a.data);
            }
            setLoading(false);
        })
    }

    useEffect(() => {
        let fetchApplicantId: number;
        if (clientId) {
            fetchApplicantId = clientId;
        } else {
            setLoading(false);
            return;
        }
        if (applicantStore.client && (fetchApplicantId == applicantStore.client.id)) {
            setLoading(false);
            return;
        }

        refresh(fetchApplicantId);
    }, [clientId]);

    return {client: applicantStore.client, loading, refresh};
}